module.exports = __webpack_public_path__ + "static/images/general/chat_white.svg";